<template>
  <div class="doctorpc-sign">
    <docpc-steps :current="stepActive"></docpc-steps>
    <div class="docpc-panel">
      <div class="form-box">
        <div class="docpc-form-title">
          印章接收
        </div>
        <van-tabs v-model="tabActive" class="docpc-tabs-card" type="card">
          <van-tab title="签收章示例">
            <div class="sign-list">
              <div class="list-item" v-for="(ritem, rindex) in sign_list" :key="rindex">
                <div class="attach-view">
                  <div class="hd">
                    <van-image width="100" height="100" :src="ritem.sample_image" fit="contain" @click="preview(ritem.sample_image)" />
                  </div>
                  <div class="bd">
                    <div class="attach-label">{{ritem.label}}</div>
                  </div>
                  <div class="ft">
                    <van-button :color="themeColor" block size="small"  @click="preview(ritem.sample_image)">查看</van-button>
                    <van-button :color="themeColor" block plain size="small"  @click="tabActive=1">上传</van-button>
                  </div>
                </div>
              </div>
            </div>
          </van-tab>
          <van-tab title="签收章上传">
            <template v-if="showUpload">
              <div class="sign-list">
                <div class="tips-msg msg-page">
                  <div class="msg-bd">
                    <div class="desc" style="color: #666;">您的备案材料已经完全审批通过，您可等待项目医生签章的发放，可在官网查询项目签章物流情况，签章接收后请提交签收章的图片，签收章图片项目办审核通过后您即正式成为援助项目医生。</div>
                  </div>
                </div>
                <div class="list-item" v-for="(upitem, upindex) in upload_list" :key="upindex">
                  <upload-attach :item="upitem" type="sign" @confirm="attachConfirm"></upload-attach>
                </div>
              </div>
              <div class="docpc-form-btn" style="margin-top: 20px;">
                <div class="btn-item">
                  <van-button :color="themeColor" block size="small" :disabled="btnDisabled" @click="submit()">提交</van-button>
                </div>
              </div>
            </template>
            <div v-else class="docpc-msg msg-page">
              <div class="msg-hd">
                <div class="msg-png" style="height: auto;">
                  <img :src="msg.png" alt="">
                </div>
              </div>
              <div class="msg-bd">
                <div class="title" v-html="msg.title"></div>
                <div class="desc" v-html="msg.desc"></div>
              </div>
              <div class="msg-ft">
                <van-button v-for="(item, index) in msgButtons" :key="index" :color="item.color" size="small" @click="item.onClick">
                  {{item.txt}}</van-button>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>

  </div>
</template>

<script>
import iconsuccess from "@/assets/docpc/icon_success.png"
import iconwarn from "@/assets/docpc/icon_warn.png"
import iconerror from "@/assets/docpc/icon_error.png"
import tempsign from "@/assets/record_table.png" // 签收表
import docpcSteps from "@/doctor_pc/components/steps/steps.vue"
import uploadAttach from "@/doctor_pc/components/upload/uploadAttach.vue"
import {
  signSubmit, doctorGetDetail,
} from '@/api/doctorapi';
import {
  GetDocSignAttach, GetDocSignExample,
} from '@/api/api';
import {
  Toast,
  Dialog,
  ImagePreview
} from "vant";
import {
  mapState,
  mapActions
} from "vuex";
import {doctorStatus} from '@/utils/doctorStatus'

export default {
  name: 'docpcSign',
  components: {
    docpcSteps,
    uploadAttach
  },
  data() {
    return {
      themeColor: this.themeColor,
      icon_success: iconsuccess,
      icon_warn: iconwarn,
      icon_error: iconerror,
      stepActive: 2,
      baseFileUrl: this.baseUrl,
      doctorInfo: null,
      btnDisabled: false,
      tabActive: 1,
      msg: {
        png: null,
        title: '',
        desc: ''
      },
      msgButtons: [],
      sign_list: [
        {
          label: '签收章',
          sample_image: tempsign
        },
      ],
      showUpload: false,
      upload_list: [
        {
          label: '签收章',
          name: 'sign',
          value: [],
          upload_filecount: 9,
        },
      ],
      statusInfo: {
        title: '',
        desc: '',
      }
    }
  },
  computed: {
    ...mapState(['docpc']),
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      await GetDocSignExample({params:{id:this.docpc.docpcInfo.doctor.id}}).then(res => {
        this.sign_list[0].sample_image = this.baseFileUrl + res.data.filepath
      }).catch(err => {
        Toast(err.response.data.message)
      })
      await doctorGetDetail({params:{id: this.docpc.docpcInfo.doctor.id}}).then(res => {
        console.log('doctorGetDetail', res.data)
        this.statusInfo = doctorStatus(res.data.doctor)
        this.doctorInfo = res.data.doctor
        if(this.doctorInfo.sign_status == '审核通过') {
          this.stepActive = 3
        }
        if(this.doctorInfo.pap_status == '已录入') {
          this.stepActive = 4
        }
        if (this.doctorInfo.sign_status=='未上传') {
          this.tabActive = 0
          this.showUpload = true
        } else {
          this.showUpload = false
          this.msg.png = this.icon_warn
          let that = this
          if (this.doctorInfo.sign_status=='已上传') {
            this.msg.title = `等待审核<br/>尊敬的${this.doctorInfo.name}医生，您好。您上传的签收文件正在审核中，请耐心等待审核结果，感谢您的配合与支持 ！`
            if (this.statusInfo.desc) {
              this.msg.title = this.statusInfo.title
              this.msg.desc = this.statusInfo.desc
            }
            this.msgButtons = []
          } else if (this.doctorInfo.sign_status=='审核不通过') {
            this.msg.png = this.icon_error
            this.msg.title = `审核不通过<br/>尊敬的${this.doctorInfo.name}医生，您好。您上传的签收文件未通过，请前往签收表重新上传！`
            this.msg.desc = `<span style="color:red;">失败原因：${this.doctorInfo.sign_reason}</span>`
            if (this.statusInfo.desc) {
              this.msg.title = this.statusInfo.title
              this.msg.desc = this.statusInfo.desc
            }
            this.msgButtons = [{
              txt: '前往签收表',
              color: this.themeColor,
              onClick: this.toSign.bind(this)
            }]
          } else if (this.doctorInfo.sign_status=='审核通过') {
            this.msg.png = this.icon_success
            this.msg.title = '申请通过'
            this.msg.desc = `尊敬的${this.doctorInfo.name}医生，您好。您上传的项目专用章回执审核已审核通过，您已正式成为“择美同行-患者援助项目”的慈善医生，感谢您对中国慈善事业的支持。`
            if (this.statusInfo.desc) {
              this.msg.title = this.statusInfo.title
              this.msg.desc = this.statusInfo.desc
            }
          }
        }
      }).catch(err => {
        Toast(err.response.data.message)
      })
      await GetDocSignAttach({params:{id:this.docpc.docpcInfo.doctor.id}}).then(res => {
        let value = []
        res.data.forEach(ele => {
          value.push({
            id: ele.id,
            src: ele.image
          })
        });
        this.upload_list[0].value = value
      }).catch(err => {
        Toast(err.response.data.message)
      })
    },
    preview(file) {
      let images = []
      images.push(file)
      this.$nextTick(() => {
        ImagePreview(images);
      })
    },
    save(item) {
      fetch(item.sample_image).then(res => res.blob().then(blob => {
        var a = document.createElement('a');
        var url = window.URL.createObjectURL(blob);
        var filename = item.label || 'pic';
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }));
    },
    attachConfirm(e) {
      console.log('attachConfirm', e, this.upload_list)
    },
    submit() {
      let that = this
      if (this.upload_list[0].value.length>0) {
        let req = {
          doctor_id: this.doctorInfo.id,
          checkItems: []
        }
        for (let i in this.upload_list[0].value) {
          let ele = this.upload_list[0].value[i]
          if (ele.is_New) {
            req.checkItems.push(ele)
          }
        }
        if (req.checkItems.length==0 && this.doctorInfo.sign_status=='审核不通过') {
          Dialog.alert({
            message: '请先更新图片，再提交',
            theme: 'round-button',
            confirmButtonText: "确定",
            confirmButtonColor: this.themeColor,
          }).then(() => {
            // on close
          });
          return
        }
        this.btnDisabled = true
        signSubmit(req).then(res => {
          console.log('signSubmit', res.data)
          this.msg.png = this.icon_success
          this.msg.title ='提交成功'
          this.msg.desc = `尊敬的${this.doctorInfo.name}医生，您好。您的材料已提交审核，请耐心等待审核结果`
          this.msgButtons = [{
            txt: '确认',
            color: this.themeColor,
            onClick: function(){ return that.getData();}
          }]
          this.showUpload = false
          this.btnDisabled = false
        }).catch(err => {
          this.btnDisabled = false
          Toast(err.response.data.message)
        })
      } else {
        Toast('请上传备案表')
      }
    },
    toSign() {
      this.tabActive = 1
      this.showUpload = true
    },
  }
}
</script>

<style lang='less'>
.doctorpc-sign {
  .sign-list {
    .list-item {
      padding: 20px 16px; border-bottom: #eee solid 1px;
      .attach-title {
        font-size: 16px; margin-bottom: 20px;
      }
      .attach-view {
        display: flex; align-items: center;
        .hd {
          margin-right: 30px;
        }
        .bd {
          flex: 1; min-width: 0; margin-right: 50px;
          .attach-label {
            font-size: 16px; margin-bottom: 10px;
          }
          .attach-desc {
            font-size: 12px; color: #666;
          }
        }
        .ft {
          padding: 0 0 0 20px; width: 100px;
          .van-button {
            margin: 10px 0;
          }
        }
        .van-image {
          background: #f3f3f3; box-shadow: 0 0 0 1px #eee;
        }
      }
      .attach-upload {
        justify-content: center;
        .bd {
          text-align: center; margin: 0;
        }
      }
      &:last-child {
        border-bottom-width: 0;
      }
    }
    .tips-msg {
      .msg-bd {
        margin: 20px; text-align: justify; text-align-last: left;
        .desc {
          text-indent: 20px; text-align: justify; text-align-last: left;
        }
      }
    }
  }
}
</style>